import { createContext, useContext } from "react";

interface IAccordionStepperContext {
  /**
   * Expand the pane with the given id, unless it is disabled.
   */
  open: (id: string) => void;
}

export const AccordionStepperContext = createContext<IAccordionStepperContext | undefined>(undefined);

export const useAccordionStepperContext = (): IAccordionStepperContext => {
  const context = useContext(AccordionStepperContext);

  if (context === undefined) {
    return {
      open: () => {
        throw new Error("Cannot call open() - component is not rendered within an AccordionStepper");
      },
    };
  }

  return context;
};
